import { Link } from 'ui/components/primitives';
import { theme, utils, styled } from 'ui/theme';

export const ListComponents = {
  Details: styled.details`
    cursor: pointer;
    list-style-type: none;
  `,

  Summary: styled.summary`
    font-family: ${theme.fonts.primary};
    color: ${theme.colors.build.darkLight};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[3]} 0;
    list-style: none;
    &::-webkit-details-marker {
      display: none;
    }
  `,

  ArrowSpan: styled.span`
    color: ${theme.colors.build.brand2};
    pointer-events: none;
  `,

  Ul: styled.ul`
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  `,

  Li: styled.li`
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.build.mediumLight1};
    padding: ${theme.space[2]} 0;
    list-style: none;
  `,
  Link: styled(Link)`
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.build.mediumLight1};
    display: flex;
    align-items: center;
    gap: ${theme.space[2]};
  `,
};

export const DividerSpan = {
  Component: styled.hr`
    border: none;
    border-top: 1px solid ${theme.colors.build.mediumLight2};
  `,
};

export const SocialComponents = {
  Component: styled.div`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[3]};
    ${utils.media.max('l')`
    padding: ${theme.space[5]} 0;
    `}
  `,
  Section: styled.div``,
  List: styled.ul`
    padding: ${theme.space[2]} 0;
    display: flex;
    gap: ${theme.space[4]};
    margin: 0;
  `,
  ItemList: styled.li`
    list-style: none;
  `,
  ImageWrapper: styled.div`
    width: 140px;
  `,
  SocialLinks: styled(Link)`
    color: ${theme.colors.build.darkLight};
  `,
};

export const InfoComponents = {
  Component: styled.div`
    display: flex;
    gap: ${theme.space[8]};
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[5]} 0;
    ${utils.media.max('l')`
    flex-direction: column;
    padding: 0;
    `}
  `,
  InfoTexts: styled.div`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[3]};
  `,
  Auxiliar: styled.div`
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.xs};
    color: ${theme.colors.build.mediumLight1};
  `,
  LogoWrapper: styled.div`
    width: 160px;
  `,
};
